import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useDeleteInventoryMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const inventoryDeleteModal: any = {};

export const InventoryDeleteModal = () => {
  const { mutate } = useDeleteInventoryMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    inventoryDeleteModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(inventoryDeleteModal).forEach((key) => {
      if (key !== 'open') delete inventoryDeleteModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: inventoryDeleteModal.id, yardId: inventoryDeleteModal.yardId },
      {
        onSuccess: () => {
          setOpen(false);
          enqueueSnackbar(MESSAGES.INVENTORY.SUCCESS.DELETED, 'success');
          inventoryDeleteModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.INVENTORY.ERROR.NOT_DELETED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'inventory-delete-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.inventoryDeleteTitle', { yardName: inventoryDeleteModal.yardName })}
        </Typography>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
